import React from 'react';
import { LinearProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { rgba } from 'polished';

// to use this component, specify:
// - value
// - customColor

// WIDTH
// - it's 56px by default
// - if custom width needed, specify it as width={123}
// - use fullWidth prop if the progress bar should take all available width of the parent

// HEIGHT
// - it's 16px by default
// - if custom height needed, specify it as height={6}

const useStyles = makeStyles({
    colorPrimary: {
        backgroundColor: (props) =>
            props.value === 0 ? '#EDEDED' : rgba(props.customColor, 0.15),
    },
    barColorPrimary: {
        backgroundColor: (props) => props.customColor,
    },
    root: {
        width: (props) => {
            if (props.fullWidth) return '100%';
            if (props.width) return props.width;
            return 56;
        },
        height: (props) => {
            if (props.height) return props.height;
            return 16;
        },
        display: 'inline-flex',
        marginRight: 10,
        borderRadius: 8,
    },
});

export function InlineProgressBar(props) {
    const { value } = props;
    const { colorPrimary, barColorPrimary, root } = useStyles(props);
    return (
        <LinearProgress
            classes={{
                colorPrimary: colorPrimary,
                barColorPrimary: barColorPrimary,
                root: root,
            }}
            color="primary"
            variant="determinate"
            value={value}
        />
    );
}
